module.exports = __webpack_public_path__ + "static/media/LegoJungleBattleAreaINTA0017_design_clean_v002.ec5386c2.png";